import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(private meta: Meta, private title: Title) {}

    public setTitle(newTitle: string) {
        this.title.setTitle(newTitle);
    }

    public updateTags(tags: any[]) {
        this.meta.addTags(tags);
    }
}